export default __webpack_public_path__ + "static/img/24.e51dfc1.png";